import client, { REWARDS_BASE_URL } from 'services/kardAPI';

const fetchLocationById = async (id) => {
  try {
    const locations = await client.get(
      `${REWARDS_BASE_URL}/portal/merchant/location/${id}`,
    );
    return locations.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default fetchLocationById;
